module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_4.132c2191.png";